import { createFileRoute } from '@tanstack/react-router';
import { RouteName } from '@mews-commander/enums';
import { FinancialServicesCapitalPage } from '@mews-commander/modules/src/modules/financialServicesCapital';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Capital')({
    component: () => <FinancialServicesCapitalPage />,
    staticData: {
        routeName: RouteName.FinancialServicesCapital,
        owner: MewsTeam.FinancialServices,
        type: RouteType.Frontend,
    },
});
